module.exports = __webpack_public_path__ + "img/ERP.49c96564.png";